import React, { useState, useEffect } from "react";
import "./sections.css";
import Gallery from "react-photo-gallery";
import gsap from "gsap";

import $ from "jquery";
import "./Creations.css";
import GalleryGameSVG from "../svg/GalleryGameSVG";
import GalleryDesignSVG from "../svg/GalleryDesignSVG";
import GalleryWebSVG from "../svg/GalleryWebSVG";
import GalleryAllSVG from "../svg/GalleryAllSVG";
import { I18nProvider } from "../../i18n";
import translate from "../../i18n/translate";
import CreationsModals from "../CreationsModals";
import { settings } from '../../settings'

let firstChange = true;
let creationsArray = shuffle([...settings.creationsArray]);
function shuffle(array) {
    var currentIndex = array.length,
        randomIndex;

    // While there remain elements to shuffle...
    while (0 !== currentIndex) {
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;

        // And swap it with the current element.
        [array[currentIndex], array[randomIndex]] = [
            array[randomIndex],
            array[currentIndex],
        ];
    }

    return array;
}


export default function Creations({ isMobile, locale, selectedSRC, setSelectedGallerySrc }) {
    const [gallery, setGallery] = useState([]);
    const [clicked, setClicked] = useState("");
    const [creationOpened, setCreationOpened] = useState(false);

    useEffect(() => {
        if (selectedSRC) {
            changeGallery($("#spanAll"), creationsArray);
            setTimeout(() => {
                let img = $("#gallery").find(`img[src$="${selectedSRC}"]`)
                let height = img.offset().top - $("#gallery").offset().top - (img.height() / 2);
                $("#gallery").animate({
                    scrollTop: height
                }, 800);
                setSelectedGallerySrc(null)
                // gsap.timeline({ repeat: 5, repeatDelay: 1.2 }).fromTo(
                //     img,
                //     { outlineOffset: '-3px', outline: '1px solid white' },
                //     {
                //         outlineOffset: '-25px',
                //         outline: '22px solid white',
                //         duration: 0.6,
                //         ease: "power4.easeIn",
                //         repeat: 1,
                //         yoyo: true,
                //     }
                // );
                gsap.timeline({ repeat: 3, repeatDelay: .6 }).fromTo(
                    img,
                    { opacity: '1' },
                    {
                        opacity: '0.3',
                        duration: 0.4,
                        repeat: 1,
                        yoyo: true,
                    }
                );
            }, 1000)
        }
    })


    const handleCloseCreationOpened = () => {
        setClicked(false);
        setCreationOpened(false);
    };

    const changeGallery = (div, array) => {
        if (div.attr("class") !== "active") {
            if (firstChange) {
                setGallery(array);
                div.toggleClass("active");
                $("#gallery").css("display", "block");
                gsap
                    .timeline({
                        onComplete: () => {
                            firstChange = false;
                        },
                    })
                    .to("#buttonGallery", {
                        transform: "rotate(0deg) translateY(0%) translateX(0%)",
                        duration: 1,
                    })
                    .to("#buttonGallery>div", {
                        transform: "rotate(0deg)",
                        duration: 1,
                        delay: -1,
                    })
                    .to("#buttonGallery>div>span", {
                        height: "12vmin",
                        width: "12vmin",
                        duration: 0.7,
                        delay: -1,
                    })
                    .to("#gallery", {
                        opacity: 1,
                        ease: "power2.easeInOut",
                        duration: 0.5,
                    });
            } else {
                $("span.active").toggleClass("active");
                div.toggleClass("active");
                gsap
                    .timeline({})
                    .to("#gallery", {
                        opacity: 0,
                        ease: "power2.easeInOut",
                        duration: 0.5,
                        onComplete: () => {
                            setGallery(array);
                        },
                    })
                    .to("#gallery", {
                        ease: "power2.easeInOut",
                        opacity: 1,
                        delay: 0.3,
                        duration: 0.5,
                    });
            }
        }
        setTimeout(() => {
            $("#gallery").on("click", function (e) {
                let clickedName;
                if (e.target.src !== undefined) {
                    let parts = e.target.src.split("/");
                    clickedName = parts[parts.length - 1];
                }
                setClicked(clickedName);
                setCreationOpened(true);
            });
        }, 1000)
    };

    return (
        <div id="creations" className="section">
            <div id="buttonGallery">
                <div id="designSelector">
                    <span
                        id="spanDesign"
                        onClick={() => {
                            changeGallery($("#spanDesign"), creationsArray.filter(x => x.type === 'design'));
                        }}
                    >
                        <GalleryDesignSVG />
                    </span>
                    <p>
                        <I18nProvider locale={locale}>
                            {translate("creationButtonDesign")}
                        </I18nProvider>
                    </p>
                </div>
                <div id="webSelector">
                    <span
                        id="spanWeb"
                        onClick={() => {
                            changeGallery($("#spanWeb"), creationsArray.filter(x => x.type === 'web'));
                        }}
                    >
                        <GalleryWebSVG />
                    </span>
                    <p>
                        <I18nProvider locale={locale}>
                            {translate("creationButtonWeb")}
                        </I18nProvider>
                    </p>
                </div>
                <div id="gameSelector">
                    <span
                        id="spanGame"
                        onClick={() => {
                            changeGallery($("#spanGame"), creationsArray.filter(x => x.type === 'game'));
                        }}
                    >
                        <GalleryGameSVG />
                    </span>
                    <p>
                        <I18nProvider locale={locale}>
                            {translate("creationButtonGame")}
                        </I18nProvider>
                    </p>
                </div>
                <div id="allSelector">
                    <span
                        id="spanAll"
                        onClick={() => {
                            changeGallery($("#spanAll"), creationsArray);
                        }}
                    >
                        <GalleryAllSVG />
                    </span>
                    <p>
                        <I18nProvider locale={locale}>
                            {translate("creationButtonAll")}
                        </I18nProvider>
                    </p>
                </div>
            </div>
            <div id="gallery" className="gallery">
                <Gallery photos={gallery} direction={"column"} />
            </div>
            <CreationsModals
                isMobile={isMobile}
                locale={locale}
                creationOpened={creationOpened}
                handleCloseCreationOpened={handleCloseCreationOpened}
                clicked={clicked}
            />
        </div>
    );
}
